// extracted by css-extract-rspack-plugin
export default {"root":"root-Cfkth9","focus":"focus-Zg4lVK","post":"post-Pv3u_O","textarea":"textarea-IwmaOU"};